var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('VerifyPhone',{attrs:{"auth-error":_vm.authError},on:{"post-phone":_vm.postPhone,"resend-code":_vm.postResend,"verify-code":_vm.postCode,"clear-auth-errors":_vm.clearAuthErrors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }